import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * Compact "you might also like" band shown above the bottom CTA on
 * project / partnership leaf pages so visitors can pivot laterally
 * without going back through the mega-menu.
 */
export const RelatedBand = ({ eyebrow = 'Related', heading, items, testId = 'related-band' }) => (
    <section
        className="border-t border-brand-hairline bg-brand-base"
        data-testid={testId}
    >
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
            <span className="eyebrow">{eyebrow}</span>
            {heading ? (
                <h2 className="h-display mt-6 max-w-3xl text-2xl sm:text-3xl">
                    {heading}
                </h2>
            ) : null}
            <div className="mt-10 grid gap-px bg-brand-hairline md:grid-cols-3">
                {items.map((it) => (
                    <Link
                        key={it.to}
                        to={it.to}
                        data-testid={`${testId}-${it.to.replace(/\//g, '-')}`}
                        className="group flex flex-col gap-3 bg-brand-surface p-6 transition-colors duration-150 hover:bg-brand-elevated md:p-8"
                    >
                        <span className="font-display text-[10px] font-bold uppercase tracking-[0.22em] text-brand-gold">
                            {it.eyebrow}
                        </span>
                        <span className="font-display text-lg font-bold uppercase tracking-tight text-brand-text">
                            {it.title}
                        </span>
                        <span className="font-sans text-sm leading-relaxed text-brand-muted">
                            {it.body}
                        </span>
                        <span className="mt-2 inline-flex items-center gap-2 font-display text-[11px] font-bold uppercase tracking-[0.18em] text-brand-blue transition-colors duration-150 group-hover:text-brand-gold">
                            Explore
                            <ArrowRight
                                size={12}
                                className="transition-transform duration-150 group-hover:translate-x-1"
                            />
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    </section>
);

export default RelatedBand;
